<script>
    import {format, parse, addDays, startOfMonth} from 'date-fns';
    import {es} from 'date-fns/locale';
    import {url, params, goto} from '@sveltech/routify'

    import {nombreCompleto} from '../../../../Modelos/Trabajador';

    import store from '../../../../Stores/Trabajadores/ver-trabajador-store';

    import Titulo from "../../../../Components/UI/Titulo.svelte";
    import Trabajador from "../../../../Components/Trabajadores/Ver/Trabajador.svelte";
    import Calendario from "../../../../Components/Trabajadores/Ver/Calendario.svelte";
    import Resumen from "../../../../Components/Trabajadores/Marcajes/Resumen.svelte";
    import Diferencia from "../../../../Components/Trabajadores/Marcajes/Diferencia.svelte";
    import Detalle from "../../../../Components/Trabajadores/Marcajes/Detalle.svelte";
    import InformacionDeMarcaje
        from "../../../../Components/Trabajadores/Marcajes/InformacionDeMarcaje.svelte";
    import EdicionDeMarcaje
        from "../../../../Components/Trabajadores/Marcajes/EdicionDeMarcaje.svelte";
    import Loading from "../../../../Components/UI/Loading.svelte";
    import Migas from "../../../../Components/UI/Migas/Migas.svelte";
    import Miga from "../../../../Components/UI/Migas/Miga.svelte";
    import EliminacionDeMarcaje
        from "../../../../Components/Trabajadores/Marcajes/EliminacionDeMarcaje.svelte";

    let cargando, trabajador, marcajes, dia, fecha, mes, tipo;
    store.cargaDatos($params.id, parse($params.fecha, 'dd-MM-yyyy', new Date()), true);

    $: {
        cargando = $store.trabajador.cargando || $store.calendario.cargando || $store.marcajes.cargando;
        fecha = $store.fecha;
        if (!cargando) {
            trabajador = $store.trabajador.trabajador;
            marcajes = $store.marcajes.marcajes;
            mes = $store.mes;
            dia = (marcajes && marcajes[fecha.getDate()]) || {
                dia: fecha.getDate(),
                tipo: mes[fecha.getDate()],
                horas: []
            };

            tipo = mes[fecha.getDate()];
        }
    }

    $: titulo = 'Marcajes diarios';

    const actualizaDia = e => {
        const nuevaFecha = addDays(fecha, e.detail);
        store.cargaDatos($params.id, nuevaFecha, true);
        $goto(`../${format(nuevaFecha, 'dd-MM-yyyy')}`);
    };

    const cambiaDia = e => {
        const nuevaFecha = e.detail.fecha;
        store.cargaDatos($params.id, nuevaFecha);
        $goto(`../${format(nuevaFecha, 'dd-MM-yyyy')}`);
    };

    let viendo = null;
    const onVerInformacion = e => viendo = e.detail;
    const onCerrarInformacion = () => viendo = null;

    let editando = null;
    const onEditar = e => editando = e.detail;
    const onCerrarEdicion = () => editando = null;
    const aceptarEdicion = e => {
        store.actualizaMarcaje(trabajador, fecha, editando, e.detail);
        editando = null;
    };

    let nuevo = null;
    const onNuevo = e => {
        const horas = dia.horas.filter(x => !x.borrado),
                ultimaHora = (horas[horas.length - 1]) || {hora: '09:00', tipo: 'Salida'};

        nuevo = {
            hora: ultimaHora.hora.split(':').map((x, i) => i === 0 ? +x + 1 : x).join(':'),
            tipo: ultimaHora.tipo === 'Salida' ? 'Entrada' : 'Salida'
        };
    };
    const onCerrarNuevo = () => nuevo = null;
    const aceptarNuevo = e => {
        store.creaMarcaje(trabajador, fecha, e.detail);
        nuevo = null;
    };

    let borrando = null;
    const onBorrar = e => borrando = e.detail;
    const onCerrarBorrado = () => borrando = null;
    const aceptarBorrado = e => {
        store.eliminaMarcaje(trabajador, fecha, borrando, e.detail);
        borrando = null;
    };
</script>

<style>
    .marcajes,
    .contenedor {
        display: grid;
        grid-gap: var(--padding-global);
    }

    @media (min-width: 768px) {
        .contenedor {
            grid-template-columns: repeat(2, 1fr);
        }

        .trabajador {
            grid-column: 1;
            grid-row: 1;
        }

        .calendario {
            grid-column: 2;
            grid-row: 1;
        }

        .marcajes {
            grid-column: 1 / 3;
            grid-row: 2;
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            grid-template-rows: max-content 1fr;
            grid-gap: var(--padding-global);
        }

        .resumen {
            grid-column: 1 / 4;
            grid-row: 1;
            display: flex;
        }

        .diferencia {
            grid-column: 4;
            grid-row: 1;
            display: flex;
        }

        .listado {
            grid-column: 1 / 5;
            grid-row: 2;
        }
    }

    @media (min-width: 1024px) {
        .contenedor {
            grid-template-columns: minmax(20em, 1fr) 3fr;
            grid-template-rows: max-content 1fr;
        }

        .trabajador {
            grid-column: 1;
            grid-row: 1;
        }

        .calendario {
            grid-column: 1;
            grid-row: 2;
        }

        .marcajes {
            grid-column: 2;
            grid-row: 1 / 3;
        }
    }
</style>

<svelte:head>
    <title>{titulo}</title>
</svelte:head>

<Migas>
    <Miga url={$url('/trabajadores')}>Trabajadores</Miga>
    {#if trabajador}
        <Miga url={$url(`/trabajadores/${trabajador.id}`)}>{nombreCompleto(trabajador)}</Miga>
        <Miga actual>{format(fecha, "d 'de' LLLL 'de' yyyy", {locale: es})}</Miga>
    {/if}
</Migas>

<Titulo>{titulo}</Titulo>

<div class="contenedor">
    {#if cargando}
        <Loading/>
    {:else}
        <div class="trabajador">
            <Trabajador/>
        </div>

        <div class="calendario">
            <Calendario calendario={mes} fecha={startOfMonth(fecha)} navegacion={false}
                        marcado={fecha} on:click-en-dia={cambiaDia}/>
        </div>

        <div class="marcajes">
            <div class="resumen">
                <Resumen {fecha} {tipo} on:cambio={actualizaDia}/>
            </div>

            <div class="diferencia">
                <Diferencia {tipo} {dia}/>
            </div>

            {#if tipo && tipo.duracion}
                <div class="listado">
                    <Detalle on:ver-informacion={onVerInformacion} on:editar={onEditar}
                             on:nuevo-marcaje={onNuevo}
                             mensajeSiNoHayDias={`Sin marcajes el día ${format(fecha, "dd 'de' LLLL 'de' yyyy", {locale: es})}`}
                             on:incorrecto={onBorrar} {dia}/>
                </div>
            {/if}
        </div>
    {/if}
</div>

{#if viendo}
    <InformacionDeMarcaje on:cancel={onCerrarInformacion} marcaje={viendo} {fecha}/>
{/if}

{#if editando}
    <EdicionDeMarcaje on:cancel={onCerrarEdicion} on:guardado={aceptarEdicion} marcaje={editando}
                      {fecha}/>
{/if}

{#if nuevo}
    <EdicionDeMarcaje on:cancel={onCerrarNuevo} on:guardado={aceptarNuevo} marcaje={nuevo}
                      {fecha}/>
{/if}

{#if borrando}
    <EliminacionDeMarcaje on:cancel={onCerrarBorrado} on:borrado={aceptarBorrado} marcaje={borrando}
                          {fecha}/>
{/if}